import { ComponentChildren } from 'preact'
import type { Step as StepType } from 'embed_v2/types/version'

type Props = {
  id: StepType['id']
  isActive: boolean
  children: ComponentChildren
}

const Step = (props: Props) => (
  <div
    id={`wf_layout_${props.id}`}
    className={`wf_reset wf_step wf_step_${props.id} ${props.isActive ? 'wf_active' : ''}`}
  >
    {props.isActive && props.children}
  </div>
)

export default Step
